import { styled } from '@linaria/react';

export const AccordionContainer = styled.details`
	overflow: hidden;
	border-radius: var(--radius-xs);
	background-color: var(--color-grey-10-solid);

	summary svg {
		transition: transform 0.2s ease;
	}

	&[open] summary svg {
		transform: rotate(90deg);
	}
	cursor: pointer;
`;

export const AccordionHeader = styled.summary`
	display: flex;
	flex-direction: row;
	align-items: center;
	align-self: stretch;
	justify-content: space-between;
	padding: 2rem;
`;

export const AccordionContent = styled.div`
	padding: 0 2rem 2rem;
	margin-top: -0.4rem;
	animation: fadeIn 0.4s ease;
	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(-5px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;
